import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "header" }
const _hoisted_2 = { style: {"width":"80%"} }
const _hoisted_3 = ["src"]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 请上传jpg/png的统一尺寸图片，图片比例为3:4，推荐尺寸：390px*520px,图片大小不能大于6M ", -1)
const _hoisted_5 = ["src"]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, " 请上传jpg/png的统一尺寸图片，图片比例为1:2，推荐尺寸：350px*700px,图片大小不能大于10M ", -1)
const _hoisted_7 = ["src"]

import { reactive, onMounted, ref } from 'vue'
import api from '@/api/index'
import { ElMessage, ElLoading, UploadProps, UploadUserFile } from 'element-plus'
import {useRouter, useRoute} from 'vue-router'


export default /*#__PURE__*/_defineComponent({
  __name: 'Edit',
  setup(__props) {

const router = useRouter()
const route = useRoute()
const baseData:any = reactive({
  loading: false,
  tipsbox: false,
  cateslist: [],
  memberlist: [],
  companylist: [],
})
const propss = {
  expandTrigger: 'hover' as const,
  value:'id',
  label:'title',
  children:'children',
}
const form = reactive({
  id: '',
  cid:'',
  img:'',
  company_id:'',
  cates: [],
  imglist: [],
  detailimglist: [],
  recommend: false,
  title:'',
  introduction: '',
  status: 0,
})
const dialogImageUrl = ref('')
const dialogVisible = ref(false)
const dialogDetailImageUrl = ref('')
const dialogDetailVisible = ref(false)

const get = () => {
  const loading = ElLoading.service({lock: true})
  api.goodsApi.get({id:route.params.id}).then((res:any)=>{
    baseData.loading = false
    if(res.code==200){
      form.id = res.data.goods.id
      form.cid = res.data.goods.cid
      form.company_id = res.data.goods.company_id
      form.cates = res.data.goods.cates ? res.data.goods.cates : []
      form.img = res.data.goods.img
      form.imglist = res.data.goods.imglist ? res.data.goods.imglist : []
      form.detailimglist = res.data.goods.detailimglist ? res.data.goods.detailimglist : []
      form.title = res.data.goods.title
      form.introduction = res.data.goods.introduction
      form.status = res.data.goods.status.toString()
      form.recommend = res.data.goods.recommend == 1 ? true : false
    }else{
      ElMessage.error(res.message)
    }
    loading.close()
  })
}
const getCatesList = () => {
  baseData.loading = true
  api.goodsApi.get_cates_list({limit:1000,page:1}).then((res:any)=>{
    baseData.loading = false
    if(res.code==200){
      baseData.cateslist = res.data.list
    }else{
      ElMessage.error(res.message)
    }
  })
}
const getCompanyList = () => {
  baseData.loading = true
  api.companyApi.list({limit:1000,page:1}).then((res:any)=>{
    baseData.loading = false
    if(res.code==200){
      baseData.companylist = res.data.list
    }else{
      ElMessage.error(res.message)
    }
  })
}
const handleChange = (value:any) => {
  if(value){
    form.cid = value[value.length - 1]
  }else{
    form.cid = ""
  }
}
const onSubmit = () => {
  const loading = ElLoading.service({lock: true})
  let data:any = {...form};
  
  if(!data.cates || data.cates == null){
    loading.close()
    ElMessage.error('请选择分类')
    return
  }else{
    data.cates = data.cates.join(',')
  }
  data.imglist = data.imglist.length ? JSON.stringify(data.imglist) : ""
  data.detailimglist = data.detailimglist.length ? JSON.stringify(data.detailimglist) : ""
  data.companyid = data.company_id
  api.goodsApi.edit(data).then((res:any)=>{
    if(res.code==200){
      ElMessage({
        message: res.message,
        type: 'success',
      })
      router.push("/goods");
    }else{
      ElMessage.error(res.message)
    }
    loading.close()
  })
}
const goBack = () => {
  router.go(-1);
}
const uploadImg = (params:any) => {
    const loading = ElLoading.service({lock: true})
    const file = params.file,formData1 = new FormData();
    formData1.append("file", file)
    api.commonApi.uploadImg(formData1).then((res:any)=>{
      loading.close()
        if(res.code == 200){
          ElMessage({
            message: res.message,
            type: 'success',
          })
          form.img = res.data.img
        }else{
          ElMessage.error(res.message)
        }
    })
  }
const uploadImgList = (params:any) => {
  const file = params.file,formData = new FormData();
  if (file.size / 1024 / 1024 > 6) {
      ElMessage.error('banner轮播图超过6MB!')
      return false
  }
  formData.append("file", file)
  api.commonApi.uploadImg(formData).then((res:any)=>{
      if(res.code == 200){
      let data = {name:file.name,url:res.data.img}
      form.imglist.pop()
      form.imglist.push(data);
      }
  })
}
const uploadDetailImg = (params:any) => {
  const file = params.file,formData = new FormData();
  if (file.size / 1024 / 1024 > 6) {
      ElMessage.error('banner轮播图超过10MB!')
      return false
  }
  formData.append("file", file)
  api.commonApi.uploadImg(formData).then((res:any)=>{
      if(res.code == 200){
      let data = {name:file.name,url:res.data.img}
      form.detailimglist.pop()
      form.detailimglist.push(data);
      }
  })
}
const handleRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
  console.log(uploadFile, uploadFiles)
}

const handlePictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
  dialogImageUrl.value = uploadFile.url!
  dialogVisible.value = true
}
const handleDetailRemove: UploadProps['onRemove'] = (uploadFile, uploadFiles) => {
  console.log(uploadFile, uploadFiles)
}

const handleDetailPictureCardPreview: UploadProps['onPreview'] = (uploadFile) => {
  dialogDetailImageUrl.value = uploadFile.url!
  dialogDetailVisible.value = true
}
onMounted(() => {
  getCatesList()
  getCompanyList()
  form.id = route.params.id
  get()
})

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_card = _resolveComponent("el-card")!

  return (_openBlock(), _createBlock(_component_el_card, { shadow: "never" }, {
    header: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_breadcrumb, {
          class: "breadcrumb",
          separator: "/"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_breadcrumb_item, { to: { path: '/goods' } }, {
              default: _withCtx(() => [
                _createTextVNode("产品列表")
              ]),
              _: 1
            }),
            _createVNode(_component_el_breadcrumb_item, null, {
              default: _withCtx(() => [
                _createTextVNode("编辑产品")
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_el_form, {
          model: form,
          "label-width": "120px"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form_item, { label: "名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: form.title,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((form.title) = $event)),
                  maxlength: "150",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "封面图" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { class: "martop" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_upload, {
                      class: "avatar-uploader",
                      action: "",
                      "http-request": uploadImg,
                      "show-file-list": false
                    }, {
                      default: _withCtx(() => [
                        (form.img)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: form.img,
                              class: "avatar"
                            }, null, 8, _hoisted_3))
                          : (_openBlock(), _createBlock(_component_el_icon, {
                              key: 1,
                              class: "avatar-uploader-icon"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_Plus)
                              ]),
                              _: 1
                            }))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "所属公司" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_select, {
                  modelValue: form.company_id,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((form.company_id) = $event)),
                  placeholder: "请选择"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(baseData.companylist, (item) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: item.id,
                        label: item.title,
                        value: item.id
                      }, null, 8, ["label", "value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "分类名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_cascader, {
                  modelValue: form.cates,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((form.cates) = $event)),
                  options: baseData.cateslist,
                  props: propss,
                  clearable: "",
                  onChange: handleChange
                }, null, 8, ["modelValue", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "轮播图" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  "file-list": form.imglist,
                  "onUpdate:fileList": _cache[3] || (_cache[3] = ($event: any) => ((form.imglist) = $event)),
                  action: "",
                  "http-request": uploadImgList,
                  "list-type": "picture-card",
                  "on-preview": handlePictureCardPreview,
                  "on-remove": handleRemove
                }, {
                  tip: _withCtx(() => [
                    _hoisted_4
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list"]),
                _createVNode(_component_el_dialog, {
                  modelValue: dialogVisible.value,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogVisible).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      "w-full": "",
                      src: dialogImageUrl.value,
                      alt: "Preview Image"
                    }, null, 8, _hoisted_5)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "推荐" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_switch, {
                  size: "large",
                  modelValue: form.recommend,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((form.recommend) = $event)),
                  "inline-prompt": "",
                  "active-text": "是",
                  "inactive-text": "否"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "简介",
              style: {"width":"100%"}
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  type: "textarea",
                  modelValue: form.introduction,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((form.introduction) = $event)),
                  maxlength: "250",
                  "show-word-limit": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "公司详情图" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  "file-list": form.detailimglist,
                  "onUpdate:fileList": _cache[7] || (_cache[7] = ($event: any) => ((form.detailimglist) = $event)),
                  action: "",
                  "http-request": uploadDetailImg,
                  "list-type": "picture-card",
                  "on-preview": handleDetailPictureCardPreview,
                  "on-remove": handleDetailRemove
                }, {
                  tip: _withCtx(() => [
                    _hoisted_6
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_Plus)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["file-list"]),
                _createVNode(_component_el_dialog, {
                  modelValue: dialogDetailVisible.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((dialogDetailVisible).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("img", {
                      "w-full": "",
                      src: dialogDetailImageUrl.value,
                      alt: "Preview Image"
                    }, null, 8, _hoisted_7)
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, { label: "状态" }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: form.status,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((form.status) = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "0" }, {
                      default: _withCtx(() => [
                        _createTextVNode("冻结")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "1" }, {
                      default: _withCtx(() => [
                        _createTextVNode("待审核")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "2" }, {
                      default: _withCtx(() => [
                        _createTextVNode("正常")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: onSubmit
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("保存")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, { onClick: goBack }, {
                  default: _withCtx(() => [
                    _createTextVNode("返回")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])
    ]),
    _: 1
  }))
}
}

})